  export const initialValues = {
    origin: "",
    agreedVolume: "",
    idCondition: null,
    quantity: "",
    description: "",
    isLimited: false,
    condition: null,
    showQuantityInput: false
  };

  export const valuesRequired = {
    origin: { required: true },
    agreedVolume: { required: true },
    idCondition: { required: true },
    quantity: { required: true },
  }